export const CREDIT_CARD_BASE_URL = '/credit-card';
export const PREFERENCES_URL = `${CREDIT_CARD_BASE_URL}/preferences/`;
export const CONSENT_REVIEW_URL = `${CREDIT_CARD_BASE_URL}/consent-review/`;
export const CARD_DELIVERY_TIME_DAYS = 5;
